export const URL_REGEX =
  /^(https?):\/\/(([\w\.-]+\.[\w\.-]+|xn--[a-z0-9-]+\.xn--[a-z0-9-]+))(\/[^\s]*)?$/;
